module.exports = __webpack_public_path__ + "static/media/get-recommendations-desktop-en.36bfeb86.webp";